import axios from "@/network";

export function apiGetSearchQuery(query: any) {
  const url = "/search";
  return axios.get(url, { params: { query } });
}
